import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ResidentDetailsTab from "../AddResident/ResidentDetailsTab";
import { useNavigate } from "react-router-dom";
// import { useEffect } from "react";
import { useParams } from "react-router-dom";

function EditResident() {
  const navigate = useNavigate();
  const { eid } = useParams();

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/ResidentManagement2")}
              />{" "}
              Edit Resident
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="residentHeading">Resident Details</div>
            <div className="residentContMain">
              <ResidentDetailsTab name={eid} />
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default EditResident;
